<template>
  <el-dialog :visible.sync="showModal" :title="id ? '编辑题目' : '添加题目'" append-to-body>
    <el-form :model="form" :rules="rules" label-width="100px" ref="form">
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model.number="form.sortNum" @input="form.sortNum = Number(form.sortNum) || ''" placeholder="关联在试卷里,序号越小越靠前" />
      </el-form-item>
      <el-form-item label="题型" prop="type">
        <el-select v-model="form.type" style="width:100%">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in subjectType" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目" prop="title">
        <QuillEditor v-model="form.title" @getText="gettitle" ref="QuillEditor_1" />
      </el-form-item>
      <el-form-item label="分值" prop="score">
        <el-input v-model.number="form.score" @input="form.score = Number(form.score) || ''" placeholder="请输入分值,1-40" maxlength="10" />
      </el-form-item>
      <el-form-item label="答案" prop="answer" v-if="form.type == 1 || form.type == 2">
        <div>
          <el-input v-model.number="form.answer" placeholder="答案请勿填写英文以外的字符，多选题时答案用英文逗号分隔" />
        </div>
        <el-alert :closable="false" title="题型为判断题时,请填写A或者B, A 表示正确,B 表示错误" class="answer_tips"></el-alert>
      </el-form-item>
      <el-form-item label="答案" v-else>
        <div>
          <QuillEditor v-model="form.answer" @getText="getanswer" ref="QuillEditor_4" />
        </div>
        <el-alert :closable="false" title="题型为判断题时,请填写A或者B, A 表示正确,B 表示错误" class="answer_tips"></el-alert>
      </el-form-item>
      <el-form-item label="材料" prop="material">
        <QuillEditor v-model="form.material" @getText="getmaterial" ref="QuillEditor_2" />
      </el-form-item>
      <el-form-item label="解析" prop="parsing">
        <QuillEditor v-model="form.parsing" @getText="getparsing" ref="QuillEditor_3" />
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input v-model="form.remarks" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QuillEditor from "@/components/QuillEditor/index.vue";
import { projectMoudel } from "../../mixins"
import { courseTypeList, subjectType } from "../../dict"
import { examTopicAdd, examTopicGet, examTopicUpdate } from "../../api"
const rules = {
  name: [
    { required: true, message: '请输入分类名称', trigger: 'blur' },
  ],
  type: [
    { required: true, message: '请选择题型', trigger: 'change' },
  ],
  title: [
    { required: true, message: '请输入题目！', trigger: 'change' },
  ],
  answer: [
    { required: true, message: '请输入答案！', trigger: 'change' },
  ],
  score: [
    {
      required: false, trigger: 'blur', validator: (rule, value, callback) => {
        if (!value) {
          return callback()
        }
        if (value <= 0 || value > 40) {
          callback(new Error('只能输入 1 ~ 40 范围之内的分值！'))
        } else {
          callback()
        }
      }
    },
  ]
}
export default {
  props: {
    examPaperId: {
      type: String,
      default: null
    }
  },
  components: { QuillEditor },
  mixins: [projectMoudel],
  data () {
    return {
      courseTypeList,
      subjectType,
      rules,
      showModal: false,
      form: {
        sortNum: null,
        type: 1,
        title: null,
        score: null,
        answer: null,
        material: null,
        parsing: null,
        remarks: null
      },
      id: null,
      inPaper: false
    }
  },
  watch: {
    showModal: {
      handler (value) {
        if (!value) {
          this.$refs.QuillEditor_1 && this.$refs.QuillEditor_1.reset()
          this.$refs.QuillEditor_2 && this.$refs.QuillEditor_2.reset()
          this.$refs.QuillEditor_3 && this.$refs.QuillEditor_3.reset()
          this.$refs['form'] && this.$refs['form'].resetFields()
        }
      }
    }
  },
  methods: {
    init (id) {
      this.form = this.$data.form
      this.showModal = true
      setTimeout(() => {
        this.getprojectPage()
        this.id = id
        if (this.id) {
          this.detail(id)
        }
      }, 200);
    },
    gettitle (text) {
      this.form.title = text
    },
    getmaterial (text) {
      this.form.material = text
    },
    getanswer (text) {
      this.form.answer = text
    },
    getparsing (text) {
      this.form.parsing = text
    },
    async detail (id) {
      const res = await examTopicGet({ id })
      const data = res.data
      if (!data) return
      Object.keys(this.form).forEach(keys => {
        this.form[keys] = data[keys]
      })
    },
    submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form }
          if (this.id) {  //编辑
            params.id = this.id
            const res = await examTopicUpdate(params)
            this.$message.success('更新成功！')
            this.showModal = false
            this.$emit('update', true)
          } else { //新增
            if (this.examPaperId) {
              params.examPaperId = this.examPaperId
            }
            const res = await examTopicAdd(params)
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('操作成功！')
            this.showModal = false
            this.$emit('update', true)
          }
        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
.answer_tips {
  margin: 12px 0 0 0;
  padding: 4px 8px;
  width: 100%;
}
</style>
